import React from 'react';
import styled from 'styled-components';
import { Table, Thead, Tbody, Row, HeadingCell, Cell } from './StyledTable';
import { ReportRow } from './ReportRow';
import { colour_lookup } from '../../common/Colours';

const StyledReports = styled.div``;

const getReportTemplate = (templates, template_id) => {
  const template =  templates.filter(template => template.id === template_id)[0] || {};
  return template;
}

export const Reports = ({ reports }: { reports: any; }) => {
  
  return (
    <StyledReports>
      <Table>
        <Thead>
          <Row>
            <HeadingCell centered={true}></HeadingCell>
            <HeadingCell centered={true}>Report</HeadingCell>
            <HeadingCell centered={true}>Positions</HeadingCell>
            <HeadingCell centered={true}>Period</HeadingCell>
            <HeadingCell centered={true}>Recipients</HeadingCell>
            <HeadingCell centered={true}>Status</HeadingCell>
            <HeadingCell centered={true}></HeadingCell>
          </Row>
        </Thead>
        <Tbody>
          {reports.map(report => (
            <ReportRow key={report.id} report={report}/>
          ))}
        </Tbody>
      </Table>
    </StyledReports>
  )
}